import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import { WizardFormError, WizardFormErrors } from '@/models/form/WizardFormError';
import { Getter, Mutation } from 'vuex-class';
import { FORM_ERRORS_OPEN, FORM_ERRORS_SHOW, SET_FORM_ERRORS_OPEN } from '@/types/form.types';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';

@Component({})
export default class SidebarErrorsComponent extends Vue {
  @Inject() public $validator;

  @Mutation(SET_FORM_ERRORS_OPEN, StoreNamespace.FORM) public setFormErrorsOpen;

  @Getter(FORM_ERRORS_OPEN, StoreNamespace.FORM) public formErrorsOpen!: boolean;
  @Getter(FORM_ERRORS_SHOW, StoreNamespace.FORM) public formErrorsShow!: boolean;

  @Prop({ type: Object as () => WizardFormErrors }) public wizardFormErrors!: WizardFormErrors;

  public declarationContent: WizardFormError = {
    sectionNumber: 6,
    message: '<span>יש למלא את ההצהרה ולשלוח את הטופס</span>',
    fieldKeys: ['declarationContent'],
  };

  private toggleErrorsSidebarOpened() {
    this.$validator.validateAll('payrollForm').then((result: any) => {
      if (!result) {
        this.$emit('client-error-focus');
      } else {
        if (this.formErrorsOpen) {
          this.setFormErrorsOpen(false);
        } else {
          this.setFormErrorsOpen(true);
        }
      }
    });
  }

  private closeErrorsSidebar(error: WizardFormError) {
    this.setFormErrorsOpen(false);
    this.$emit('side-error-clicked', error);
  }

}

